module.exports = __webpack_public_path__ + "6fa5d9d58dfc14ce4da607baa295d6fd.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/up-29.png
// module id = 2641
// module chunks = 0